// extracted by mini-css-extract-plugin
export default {"ShopPage":"ShopPage_ShopPage__ezQyN"};